import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { Provider } from 'src/typings';
import { ProviderService } from '../provider.service';

@Component({
  selector: 'app-upload-settings',
  templateUrl: './upload-settings.component.html',
  styleUrls: ['./upload-settings.component.scss']
})
export class UploadSettingsComponent {
  constructor(private fb: FormBuilder, private providerService: ProviderService) {}

  loading = false;

  @Input() set provider(payload: Provider | undefined) {
    this._provider = payload;
    const { description, brand, article, price } = this.form.controls;
    description.setValue(payload?.uploadDescription);
    brand.setValue(payload?.uploadBrand);
    article.setValue(payload?.uploadArticle);
    price.setValue(payload?.uploadPrice);
  }

  private _provider?: Provider;

  get provider() {
    return this._provider;
  }

  form = this.fb.group({
    description: new FormControl(),
    brand: new FormControl(),
    article: new FormControl(),
    price: new FormControl()
  });

  async save() {
    const { description, brand, article, price } = this.form.value;
    if (!this.provider) return;
    this.loading = true;
    await firstValueFrom(
      this.providerService.updateUploadSettings({
        uploadArticle: article,
        uploadBrand: brand,
        uploadDescription: description,
        uploadPrice: price,
        id: this.provider.id
      })
    );
    this.loading = false;
  }
}
